import { Controller, useFormContext } from 'react-hook-form'

import { sarSubjectIdentificationTypes } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const IdForm = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control, setValue, clearErrors } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idForm`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="Type"
          input={(props) => (
            <Select
              {...props}
              data={sarSubjectIdentificationTypes}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={isAllInfoUnavailable}
              onChange={(value) => {
                if (value !== 'Other') {
                  setValue(`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idFormOther`, '')
                  clearErrors(`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idFormOther`)
                }
                field.onChange(value)
              }}
            />
          )}
        ></FF2>
      )}
    />
  )
}
